var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.35 397.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9da7aa;}.cls-2{fill:#afd8d8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.68,310H438a123.91,123.91,0,0,0,50-10.37c.95-.42,1.87-.84,2.74-1.26,35.14-16.93,76.08-75.7,25.61-121.65-66.64-60.7-144-8.34-144-8.34s-15.82-81.57-86.66-79.45c-70.43,2.1-88.28,50.89-94.23,73.5,0,0-77.35-53.55-128.52-14.28-39.44,30.27-14.28,77.36-14.28,77.36s-57.85,19.83-37.88,58.81C19,300.27,35.76,310,53.68,310Z",
    transform: "translate(-6.65 -88.89)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.49,326.66S92,389.15,98.89,403,131.87,383.94,147.49,326.66Z",
    transform: "translate(-6.65 -88.89)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.15,326.36s-55.55,62.49-48.61,76.38S256.52,383.64,272.15,326.36Z",
    transform: "translate(-6.65 -88.89)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.67,326.36s-55.54,62.49-48.6,76.38S385.05,383.64,400.67,326.36Z",
    transform: "translate(-6.65 -88.89)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.3,406.56s-55.55,62.49-48.6,76.38S165.68,463.84,181.3,406.56Z",
    transform: "translate(-6.65 -88.89)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.44,406.27s-55.55,62.49-48.61,76.37S299.81,463.55,315.44,406.27Z",
    transform: "translate(-6.65 -88.89)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.386fab05.svg";
export { ForwardRef as ReactComponent };